import { Box, Grid, Typography, Button, IconButton } from '@mui/material';
import { useEffect, useState, useMemo } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
// import { makeStyles } from '@material-ui/core/styles';
import { makeStyles } from '@mui/styles';
import { useMainFrameDispatch } from '../../component/MainUIFrame/MainFrame';
import {
  ACTION_LEFT_DRAWER,
  ACTION_LEFT_DRAWER_JSX,
  ACTION_LEFT_DRAWER_NOT,
  ACTION_MAIN_BOTTOM_BAR_JSX,
  ACTION_OPEN_TOOLBAR,
  ACTION_RESET,
  ACTION_SET_APPBAR_JSX,
  ACTION_SET_TOOLBAR_JSX,
} from '../../component/MainUIFrame/constants';
import EHRToolbar from '../../component/Toolbar/toolbarContent';
import LeftDrawerContent from '../ehr/contents/drawerContent/leftDrawerContent';
import { useDispatch, useSelector } from 'react-redux';
import { setToolbarButtons } from '../../redux/features/toolbarSlice';
import { toolbarConstants } from '../../constants/toolbar/toolbarConstants';
import { clearChargeItem } from '../../redux/features/invoiceSlice';
import { getDateOnly } from '../../config/common';
import InvoiceNewPage from './invoiceNewPage';
// import { dataGridStyle } from '../../themes/mui-grid';
import { ehrAPIBaseService } from '../../http-common';
import dayjs from 'dayjs';
import EHRBottomBar from '../Practitioner/contents/bottomBarContent';
import { useRef } from 'react';
import { useMainFrameState } from '../../component/MainUIFrame/MainFrame';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import '../../themes/ag-grid/enliv-grid-theme.scss';
import { components } from '../../config/common';
import PrintInvoice from './printInVoice';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

const columnData = [
  {
    checkboxSelection: params => {
      return params?.data?.id !== 'No Data Found';
    },
    field: 'id',
    headerName: 'Id',
    flex: 1,
    filter: 'agTextColumnFilter',
    //hide: true,
    filter: false,
    tooltipField: 'id',
  },
  {
    field: 'patient',
    headerName: 'Patient Name',
    flex: 1,
    filter: 'agTextColumnFilter',
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    filter: 'agTextColumnFilter',
  },
  {
    field: 'date',
    headerName: 'Invoice Created Date',
    flex: 1,
    filter: 'agTextColumnFilter',
    filter: false,
  },
];

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer':
      {
        display: 'none',
      },
  },
}));

const InvoiceListNew = () => {
  const navigate = useNavigate();
  const reduxDispatch = useDispatch();
  const dispatch = useMainFrameDispatch();
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );
  // const classes = dataGridStyle();
  const [listView, setListView] = useState(true);
  const [isDisabled, setDisabled] = useState(true);
  const [selectionModel, setSelectionModel] = useState();
  const [invoiceObject, setInvoiceObject] = useState({});
  const [getPatinetDetails, setPatientId] = useState();
  const [rowData, setRowData] = useState([]);
  const [chargeItems, setChargeItems] = useState([]);
  const [isAddbtnDisabled, setAddbtnDisabled] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [currentSelectedRow, setCurrentSelectedRow] = useState({});
  const gridRef = useRef();
  // const gridStyle = useMemo(
  //   // () => ({ width: '100%', height: window.outerHeight - 270 }),
  //   () => ({
  //     width: '100%',
  //     height:
  //       window.screen.height * window.devicePixelRatio >= 900
  //         ? window.outerHeight - 280
  //         : window.outerHeight - 150,
  //   }),
  //   [window.onresize]
  // );
  const gridStyle = useMemo(() => ({ width: '100%' }), []);
  const { isDark } = useMainFrameState();
  const defaultColDef = useMemo(() => {
    return {
      filter: true,
      floatingFilter: true,
      // flex: 1,
      // minWidth: 100,
      // sortable: true,
    };
  }, []);
  const onGridReady = params => {
    if (gridRef && gridRef.current) {
      gridRef.current.api.purgeInfiniteCache();
    }
    params.api.setDatasource(dataSource);
  };
  let [realTotalPage, setRealTotalPage] = useState(0);
  let openPageToken = '';

  const AppBarJsx = props => {
    return (
      <Grid container>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {!listView && (
            <IconButton>
              <ArrowBack
                onClick={() => handleOnClose()}
                sx={{
                  color: 'appBarIcon',
                }}
              />
            </IconButton>
          )}
          <Typography
            sx={{
              color: 'appBarIcon',
            }}
            variant="h5"
          >
            {'Invoice'}
          </Typography>
        </Box>
      </Grid>
    );
  };

  useEffect(() => {
    dispatch({
      type: ACTION_SET_APPBAR_JSX,
      payload: <AppBarJsx handleOnClose={handleOnClose} listView={listView} />,
    });
  }, [listView]);

  useEffect(() => {
    const handleBrowserBack = () => {
      console.log('Browser back arrow was pressed!');
      setListView(true);
    };
    window.addEventListener('popstate', handleBrowserBack);
    return () => {
      window.removeEventListener('popstate', handleBrowserBack);
    };
  }, [navigate]);

  const handleOnClose = () => {
    setListView(true);
  };

  const dataSource = {
    async getRows(params) {
      const { startRow, endRow, filterModel, sortModel } = params;
      let url = `fhir/search/`;
      let _resourseType = `Invoice`;
      let _pageToken = `_page_token=${openPageToken}`;
      let _offset = `_offset=${parseInt(startRow)}`;
      let _count = `_count=${parseInt(endRow - startRow)}`;
      let _sort = `_sort=-lastUpdated`;

      //Sorting
      // if (sortModel.length) {
      //   const { colId, sort } = sortModel[0];

      //   if (colId === 'patient') {
      //     if (sort === 'asc') {
      //       _sort += `,name`;
      //     } else {
      //       _sort += `,-name`;
      //     }
      //     // openPageToken = "";
      //   }
      // }

      url += `${_resourseType}?${_offset}&${_count}&${_sort}`;
      const filterKeys = Object.keys(filterModel);

      filterKeys.forEach(filter => {
        // url += `${filter}=${filterModel[filter].filter}&`
        if (filter === 'status') {
          url += `&status:contains=${filterModel[filter].filter}`;
          // url += `&_filter=name co ${filterModel[filter].filter}`
          // url += `&address-city:contains=${filterModel[filter].filter}`;
          // openPageToken = "";
        }
        if (filter === 'patient') {
          url += `&subject:Patient.name=${filterModel[filter].filter}`;
          // openPageToken = "";
        }
      });

      if (!_.isEmpty(openPageToken) && endRow > 10) {
        url += `&${_pageToken}`;
      }

      try {
        const response = await ehrAPIBaseService.get(url);
        console.log('response of invoice ', response);
        let tempRows = [];
        for (const item of response?.data?.entry) {
          let singleRow = {};
          singleRow.id = _.get(item, 'resource.id', '');
          singleRow.status = _.capitalize(_.get(item, 'resource.status', ''));
          singleRow.date = dayjs(_.get(item, 'resource.date', '')).format(
            'MM/DD/YYYY'
            // selectedVersion == 'IN' ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
          );
          singleRow.patient = _.get(item, 'resource.subject.display', '');
          singleRow.patientId = _.get(item, 'resource.subject.reference').split(
            '/'
          )[1];
          singleRow.totalPriceComponent = _.get(
            item,
            'resource.totalPriceComponent[0].amount.value'
          );
          tempRows.push(singleRow);
        }
        if (startRow === 0) {
          realTotalPage = response?.data?.total;
        }
        const nextPageToken = response?.data?.link
          .find(link => link.relation === 'next')
          ?.url?.split('_page_token=')?.[1];
        if (nextPageToken) {
          openPageToken = nextPageToken;
        } else {
          openPageToken = null; // Clear the token if it's not provided
        }
        console.log('temp rows :', tempRows);
        params.successCallback(tempRows, realTotalPage, startRow + 1);
      } catch (e) {
        console.error(`EHR->ehrGetAllInvoices ${e}`);
        params.successCallback([{ id: 'No Data Found' }], 1, 1);
      }
    },
  };

  const getInvoiceList = async () => {
    try {
      const response = await ehrAPIBaseService.get(
        `fhir/search/?resourceType=Invoice`
      );
      console.log('response of invoice ', response);
      let tempRows = [];
      for (const item of response?.data?.entry) {
        let singleRow = {};
        singleRow.id = _.get(item, 'resource.id', '');
        singleRow.status = _.capitalize(_.get(item, 'resource.status', ''));
        singleRow.date = dayjs(_.get(item, 'resource.date', '')).format(
          'MM/DD/YYYY'
        );
        singleRow.patient = _.get(item, 'resource.subject.display', '');
        singleRow.totalPriceComponent = _.get(
          item,
          'resource.totalPriceComponent[0].amount.value'
        );
        tempRows.push(singleRow);
      }
      console.log('temp rows pat id:', tempRows);
      setRowData(tempRows);
      console.log('items of charge ', rowData);
      //setPatientId(tempRows);
    } catch (e) {
      console.error(`EHR->ehrGetAllInvoices ${e}`);
    }
  };

  const navigateToInvoiceView = create => {
    navigate(`/invoice/${create ? 'add' : 'view'}`, {
      state: {
        invoiceObject: create ? {} : invoiceObject,
        patientDetails: getPatinetDetails,
        isEdit: create ? false : true,
        listView: false,
        isDark: isDark,
      },
    });
  };

  useEffect(() => {
    getInvoiceList();
    dispatch({ type: ACTION_LEFT_DRAWER });
    // dispatch({ type: ACTION_RIGHT_DRAWER });
    return () => {
      dispatch({ type: ACTION_LEFT_DRAWER_NOT });
      // dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
      // dispatch({ type: ACTION_CLOSE_TOOLBAR })
    };
  }, [listView]);

  useEffect(() => {
    listView &&
      reduxDispatch(
        setToolbarButtons({
          actions: [
            {
              key: toolbarConstants.CREATE,
              clickAction: () => {
                // setInvoiceObject({});
                // setEdit(false);
                // setListView(false);
                reduxDispatch(clearChargeItem());
                navigateToInvoiceView('create');
              },
            },
            {
              key: toolbarConstants.OPEN,
              clickAction: () => {
                // setListView(false);
                // setEdit(true);
                navigateToInvoiceView();
              },
              disabled: isDisabled,
            },
          ],
          module: 'Invoice',
          // editSwitch: true,
          editSwitch: false,
        })
      );
    return () => listView && reduxDispatch(setToolbarButtons({ actions: [] }));
  }, [listView, isDisabled]);

  useEffect(() => {
    dispatch({ type: ACTION_OPEN_TOOLBAR });
    dispatch({
      type: ACTION_SET_TOOLBAR_JSX,
      payload: <EHRToolbar />,
    });
    dispatch({ type: ACTION_SET_APPBAR_JSX, payload: <AppBarJsx /> });
    return () => {
      dispatch({
        type: ACTION_RESET,
      });
      reduxDispatch(clearChargeItem());
    };
  }, []);

  //cc//
  useEffect(() => {
    dispatch({
      type: ACTION_MAIN_BOTTOM_BAR_JSX,
      payload: <EHRBottomBar />,
    });

    return () => {
      dispatch({
        type: ACTION_RESET,
      });
    };
  }, []);
  //cc//

  // useEffect(() => {
  //   dispatch({
  //     type: ACTION_LEFT_DRAWER_JSX,
  //     payload: <LeftDrawerContent data={currentSelectedRow} />,
  //   });
  // }, [currentSelectedRow]);

  return (
    <>
      <Grid
        container
        // className={listView ? 'overflow' : ''}
        // style={{ padding: '2%', paddingRight: '0%' }}
      >
        {listView ? (
          <Grid container>
            <Grid
              container
              sx={{
                padding: 0,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            ></Grid>
            <Grid
              item
              xs={12}
              // variant="div"
              // // style={gridStyle}
              // sx={{
              //   width: '100%',
              // }}
              // className={isDark ? 'ag-theme-custom pm-0' : 'ag-theme-alpine pm-0'}
            >
              <div
                style={gridStyle}
                className={
                  isDark
                    ? 'ag-theme-custom overflow-grid pm-0'
                    : 'ag-theme-alpine overflow-grid pm-0'
                }
              >
                <AgGridReact
                  domLayout="autoHeight"
                  ref={gridRef}
                  columnDefs={columnData}
                  defaultColDef={defaultColDef}
                  rowSelection={'single'}
                  paginationPageSize={10}
                  rowModelType="infinite"
                  components={components}
                  cacheBlockSize={10}
                  cacheOverflowSize={2}
                  maxConcurrentDatasourceRequests={2}
                  infiniteInitialRowCount={1}
                  maxBlocksInCache={2}
                  pagination={true}
                  animateRows={true}
                  onSelectionChanged={params => {
                    const selectedRowData =
                      gridRef?.current?.api?.getSelectedRows();
                    setSelectionModel(selectedRowData[0?.id]);
                    let sRow =
                      selectedRowData.length > 0 &&
                      selectedRowData[selectedRowData.length - 1];
                    console.log(sRow);
                    if (sRow?.id !== 'No Data Found') {
                      setCurrentSelectedRow(sRow);
                    }
                    if (sRow && sRow?.id !== 'No Data Found') {
                      console.log('s row ', sRow);
                      setInvoiceObject(sRow);
                      setDisabled(false);
                    } else {
                      setInvoiceObject({});
                      setDisabled(true);
                    }
                  }}
                  onRowClicked={event => {
                    const clickedRowData = event?.data;
                    if (
                      clickedRowData &&
                      clickedRowData?.id !== 'No Data Found'
                    ) {
                      if (clickedRowData === currentSelectedRow) {
                        setTimeout(() => {
                          gridRef?.current?.api?.deselectAll();
                          setCurrentSelectedRow({});
                        }, 200);
                      } else {
                        setCurrentSelectedRow(clickedRowData);
                      }
                    } else {
                      setCurrentSelectedRow({});
                    }
                  }}
                  onRowDoubleClicked={event => {
                    if (event?.data && event?.data?.id !== 'No Data Found') {
                      setCurrentSelectedRow(event.data);
                      setInvoiceObject(event.data);
                      navigateToInvoiceView();
                    }
                    // setListView(false);
                    // setEdit(true);
                  }}
                  onGridReady={onGridReady}
                  suppressColumnMoveOutside={true}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          // <Grid container>
          //   <Grid item xs={12} className="overflow">
          //     <DataGrid
          //       className={classes.root}
          //       autoHeight
          //       rows={rowData}
          //       columns={columnData}
          //       pageSize={10}
          //       rowsPerPageOptions={[10]}
          //       checkboxSelection
          //       selectionModel={selectionModel}
          //       onSelectionModelChange={ids => {
          //         const selectionSet = new Set(selectionModel);
          //         const result = ids.filter(s => !selectionSet.has(s));
          //         setSelectionModel(result);

          //         const selectedRowData = ids.map(id =>
          //           rowData.find(row => row.id === id)
          //         );
          //         let sRow =
          //           selectedRowData.length > 0 &&
          //           selectedRowData[selectedRowData.length - 1];
          //         console.log(sRow);
          //         setCurrentSelectedRow(sRow);
          //         if (sRow) {
          //           setInvoiceObject(sRow);
          //           setDisabled(false);
          //         } else {
          //           setInvoiceObject({});
          //           setDisabled(true);
          //         }
          //       }}
          //       onRowDoubleClick={event => {
          //         setCurrentSelectedRow(event.row);
          //         setInvoiceObject(event.row);
          //         setListView(false);
          //         setEdit(true);
          //       }}
          //     />
          //   </Grid>
          // </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            item
            xs={12}
          >
            {/* <PrintInvoice
              invoiceObject={invoiceObject}
              patientDetails={getPatinetDetails}
              isEdit={isEdit}
              listView={listView}
              setListView={setListView}
              setSelectionModel={setSelectionModel}
              setDisabled={setDisabled}
              isDark={isDark}
            /> */}
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default InvoiceListNew;
